import atimg1 from '../images/team/team1.jpg';
import atimg2 from '../images/team/team2.jpg';
import atimg3 from '../images/team/team3.jpg';

const Attorneys = [
  {
    Id: '1',
    AtImg: atimg1,
    name: 'Pablo Hernández Arias',
    name_page: 'Pablo Hernández Arias (MBL)',
    title: 'CEO de H&A Abogados',
    parrafo:
      'CEO de H & A Abogados, encargado del área comercial y civil de la empresa. Responsable del asesoramiento de empresas nacionales y extranjeras tanto en su apertura, funcionamiento y defensa de sus negocios. Encargado en el asesoramiento legal de establecimientos educacionales. Abogado Universidad Andrés Bello, Magíster en Derecho de los Negocios, L.L.M Business Law, Escuela de Negocios, Universidad Adolfo Ibáñez, Diplomado en Derecho a la Salud y Responsabilidad Civil Médica, Universidad Diego Portales y Curso de "Coaching Ejecutivo" de Programa de Capacitación y Desarrollo Integral, Pontificia Universidad Católica de Chile. Diplomado de Redacción Creativa en la Universidad Diego Portales. Diplomado en Lectura Crítica, Escuela de Artes de la Universidad Adolfo Ibáñez. Curso Ley Karin N°21.643, año 2025. Cursando Magíster en Literatura Comparada, Escuela de Artes, de la Universidad Adolfo Ibáñez.',
    linkedin: 'https://www.linkedin.com/in/pablo-hern%C3%A1ndez-arias-hya/',
  },
  {
    Id: '2',
    AtImg: atimg2,
    name: 'Daniela Sepúlveda Carvajal',
    name_page: 'Daniela Sepúlveda Carvajal',
    title: 'Asesora Legal de H&A Abogados',
    parrafo:
      'Asesora Legal en H & A Abogados. Encargada del área de resolución de conflictos en Convivencia Escolar. Consultoría para entidades sin fines de lucro, del ámbito educacional y privado. Práctica profesional Corporación de Asistencia Judicial de Independencia. Estudiante de Derecho de la Universidad Finis Terrae. Cursos de Filosofía Contemporánea; Pensamiento, discurso y argumentación. Ambos, de las Escuelas de Verano de la Universidad de Chile. Curso sobre  Problemas Actuales de la Responsabilidad Civil, de la Universidad Adolfo Ibáñez. Diplomado en Gestión de la Convivencia Escolar en la Universidad Finis Terrae.',
    linkedin: 'https://www.linkedin.com/in/daniela-sep%C3%BAlveda-carvajal/',
  },
  {
    Id: '3',
    AtImg: atimg3,
    name: 'Vanessa Chávez Chacaltana',
    name_page: 'Vanessa Chávez Chacaltana',
    title: 'Consultora Externa de H&A Abogados',
    parrafo:
      'Consultora externa de H & A Abogados, especialista en derecho laboral, del ámbito individual, colectivo y recursos humanos. Práctica profesional Defensoría Laboral de Arica. Egresada de Derecho de la Universidad de Valparaíso. Relatora en materias de prevención e investigación de eventos adversos laborales.',
    linkedin: 'https://www.linkedin.com/in/vanessachavezch/',
  },
];

export default Attorneys;
